/**
 * 设置cookie
 * @param {String} key  cookie 的ky key
 * @param {String} value cookie 的 value
 * @param {String} string cookie 的过期时间
 */


function setCookie(key, value, t = 0) {
  let date = new Date()
  let val
  // val = JSON.stringify(value)
  val = value
  date.setDate(date.getDate + t)
  document.cookie = `${key}=${val};path=/;expires=${date.toDateString()}`
}
/**
 * 获取cookie
 * @param {String} key  cookie 的 key
 */
function getCookie(key) {
  let cookies = document.cookie.split(';')
  let value
  cookies.forEach(item => {
    let cookieArr = item.split('=')
    if (cookieArr[0].trim() === key) {
      value = cookieArr[1]
    }
  })
  return value
}
/**
 * 移除cookie
 * @param {String} key  cookie 的ky key
 */
function removeCookie(key) {
  setCookie(key, "", -1);
}

module.exports = {
  setCookie,
  getCookie,
  removeCookie
}
